import { create } from "zustand";
import { IUserWifi } from "@/types/user.types";

export const useUserWifi = create<IUserWifi>((set) => ({
  name: "",
  ssid: "",
  wifi_pass: "",
  network_type: "WPA",
  isDownload: false,
  config: {},
  destroyUSerWifi: () => {
    set({
      name: "",
      ssid: "",
      wifi_pass: "",
      wifi_hidden: "off",
      network_type: "WPA",
      isDownload: false,
      config: {},
    });
  },
  setParams: (val) => {
    set((state) => {
      return { ...state, ...val };
    });
  },
  setConfig: (val) => {
    set((state) => {
      return { ...state, config: { ...state.config, ...val } };
    });
  },
  setDelete: (val) =>
    set((state) => {
      delete state[val];
      return state;
    }),
}));
